import React, { useEffect, useState } from "react";
import * as Yup from "yup";

import Form from "@Components/Form";
import {
  ID_TYPES_URL,
  URLS,
  WORKER_TYPES_URL,
  ZONE_FETCH_URL,
  REGION_FETCH_URL,
  ESTATE_FETCH_URL,
  DIVISION_FETCH_URL,
  BLOCK_FETCH_URL,
  LIST_WORKER_GROUP_URL,
  NATIONALITIES_LIST_URL,
  PASSPORT_STATUS_URL,
  PASSPORT_RENEWAL_STATUS_URL,
  PERMIT_STATUS_URL,
  PERMIT_RENEWAL_STATUS_URL
} from "configs/constants";
import eightAxios from "../../configs/axiosConfig";
import { SOURCE_FETCH_URL } from "configs/constants";
import { COMPANY_FETCH_URL } from "configs/constants";
let API_URL = "new-user/";



const validationSchema = Yup.object({
  employee_id: Yup.string()
    .required("Employee id is required")
    .typeError("Invalid employee id"),
  name: Yup.string()
    .required("Worker name is required")
    .typeError("Invalid employee name"),
  id_type: Yup.string()
    .required("ID type is required")
    .typeError("Invalid id type")
    .nullable(),
  id_number: Yup.string()
    .required("ID Number is required")
    .typeError("Invalid ID Number"),
  nationality: Yup.string()
    .required("Nationality is required")
    .typeError("Invalid nationality"),
  mobile_number: Yup.string()
    .required("Mobile Number is required")
    .matches(/^[0-9]+$/, "Mobile Number must contain only digits")
    .matches(/^\S*$/, "Spaces at the beginning or end are not allowed")
    .min(8, "Invalid length Min 10, Max 12")
    .max(12, "Mobile Number must not exceed 12 digits")
    .typeError("Invalid mobile number"),
  worker_group: Yup.string()
    .required("Worker group is required")
    .typeError("Invalid worker group")
    .nullable(),
  worker_type: Yup.string()
    .required("Worker type is required")
    .typeError("Invalid worker type")
    .nullable(),
  zone: Yup.string()
    .required("Zone is required")
    .typeError("Invalid Zone")
    .nullable(),
  region: Yup.string()
    .required("Region is required")
    .typeError("Invalid Region")
    .nullable(),
  estate: Yup.string()
    .required("Estate is required")
    .typeError("Invalid Estate")
    .nullable(),
  source: Yup.string()
    .required("Source is required")
    .typeError("Invalid source name")
    .nullable(),

  company: Yup.string()
    .required("Company is required")
    .typeError("Invalid company name")
    .nullable(),
});
const WorkerCreateForm = () => {
  const [selectedWorkerGroup, setSelectedWorkerGroup] = useState(null);
  const [supervisor, setSupervisor] = useState("");
  const [showDocuments, setShowDocuments] = useState(false);
  const [selectedWorkerType, setSelectedWorkerType] = useState('');
  const [key, setKey] = useState(1);
  const [selectedErmlType,setSelectedErmlType] =useState(false);
  const [disableswitch,setDisableswitch] = useState(false);
  const [selectedNationalityType,setSelectedNationalityType] =useState('');
  const [selectedIdType, setSelectedIdType] = useState('');
  const [disabledWorkerType,setDisabledWorkerType] = useState(false);
  const [disabledNationalityType,setDisabledNationalityType] = useState(false);
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);
  const [disableDivision, setDisableDivision] = useState(true);
  const [disableBlock, setDisableBlock] = useState(true);
  const [disableCompany, setDisableCompany] = useState(true);
  const [disableZone, setDisableZone] = useState(true);


  const getZoneValues = (e,setDisableRegion) => {
  //  if (!e || e.length === 0) {
    if (!e || e.length === 0 || e.label == "N/A") {
      setDisableRegion(true);
    }
    else {
      setDisableRegion(false);
    }
    
  };
  const getSourceValue = (e,setDisableCompany) => {
    if (!e || e.length === 0) {
      setDisableCompany(true);
    }
    else {
      setDisableCompany(false);
    }
    
  };
  const getRegionValues = (e,setDisableEstate) => {
    if (!e || e.length === 0) {
      setDisableEstate(true);
    }
    else {
      setDisableEstate(false);
    }
    
  };

  const getEstateValues = (e,setDisableDivision) => {
    if (!e || e.length === 0) {
      setDisableDivision(true);
    }
    else {
      setDisableDivision(false);
    }
    
  };
  const getDivisonValues = (e,setDisableBlock) => {
    if (!e || e.length === 0) {
      setDisableBlock(true);
    }
    else {
      setDisableBlock(false);
    }
    
  };
  const getErmlType = (e) => {

    if(e?.value == true){
      setDisableswitch(true);
  
    }
    else{
      setDisableswitch(false);
  
    }
      setSelectedErmlType(e?.value);
  
    };
  
  useEffect(() => {
   
    if (selectedWorkerType == "Foreign") {
      setShowDocuments(true);
    }else {
      setShowDocuments(false);
    }
    
    if (selectedWorkerGroup) {
      eightAxios
        .get(`supervisor-assignment/${selectedWorkerGroup}/get-supervisor/`)
        .then((res) => {
          setSupervisor(res.data);
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      setSupervisor(null);
    }
  }, [selectedWorkerGroup, selectedWorkerType]);

  const getCompanyValues = (e, setDisableZone) => {
    if (!e || e.length === 0) {
      setDisableZone(true);
    }
    else {
      setDisableZone(false);
    }
  
  };
  const getIdType = (e) => {


    if(e?.label == "IC" ){      
      setSelectedIdType(e?.value)
      setDisabledWorkerType(true);
      setSelectedWorkerType("Local");
      setSelectedNationalityType("Malaysia");
      setDisabledNationalityType(true);
    }
    if(e?.label == "PASSPORT" ){
      setSelectedIdType(e?.value)
      setDisabledWorkerType(true);
      setSelectedWorkerType("Foreign");
      setSelectedNationalityType('');
      setDisabledNationalityType(false);
    }
  };
  
  const getNationalityType = (e) => {
    console.log('e',e)

    //setSelectedNationalityType(e?.value);
  };

  const getWorkerGroup = (e) => {
    setSelectedWorkerGroup(e?.value);
  };

  const getWorkerType = (e) => {
    console.log('e',e)
    //setSelectedWorkerType(e?.value);
  };

  const documentFields = [
    { type: "title", title: "Document Details", showField: showDocuments },
    {
      type: "datepicker",
      size: "small",
      helperText: "",
      name: "passport_start_date",
      label: "Passport Start Date",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    {
      type: "datepicker",
      name: "passport_expiry_date",
      autoComplete: "off",
      size: "small",
      helperText: "",
      label: "Passport Expiry Date",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    {
      type: "reactselect",
      name: "passport_status",
      label: "Passport Status",
      size: "small",
      proxyUrl: PASSPORT_STATUS_URL,
      paginated: true,
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    {
      type: "reactselect",
      name: "passport_renewal_status",
      label: "Passport Renewal Status",
      size: "small",
      proxyUrl: PASSPORT_RENEWAL_STATUS_URL,
      paginated:true,
    
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    {
      type: "datepicker",
      name: "passport_renewal_start_date",
      autoComplete: "off",
      size: "small",
      helperText: "",
      label: "Passport Renewal Start Date",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    
    {
      type: "input",
      name: "permit_number",
      label: "Permit Number",
      size: "small",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    {
      type: "datepicker",
      name: "permit_start_date",
      label: "Permit Start Date",
      autoComplete: "off",
      size: "small",
      helperText: "",
      
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    {
      type: "datepicker",
      name: "permit_expiry_date",
      label: "Permit Expiry Date",
      autoComplete: "off",
      size: "small",
      helperText: "",
      
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    
    
    {
      type: "reactselect",
      name: "permit_status",
      label: "Permit Status",
      size: "small",
      proxyUrl: PERMIT_STATUS_URL,
      paginated:true,
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    {
      type: "reactselect",
      name: "permit_renewal_status",
      label: "Permit Renewal Status",
      proxyUrl: PERMIT_RENEWAL_STATUS_URL,
      paginated:true,
      size: "small",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    {
      type: "datepicker",
      name: "permit_renewal_start_date",
      label: "Permit Renewal Start Date",
      size: "small",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    {
      type: "datepicker",
      name: "contract_start_date",
      label: "Contract Start Date",
      size: "small",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
    {
      type: "datepicker",
      name: "contract_expiry_date",
      label: "Contract Expiry Date",
      size: "small",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      showField: showDocuments
      // required: true,
    },
  ]
  const initialValues = {
    id_type: "",
    id_number: "",
    name: "",
    username: "",
    mobile_number: "",
    employee_id: "",
    zone: "",
    source:"",
    company: "",
    region: "",
    estate: "",
    division: "",
    block: "",
    nationality: "",
    worker_group: "",
    profile_type: "Worker",
    worker_type:null,
    passport_start_date: null,
    passport_expiry_date: null,
    passport_status: null,
    passport_renewal_status: null,
    passport_renewal_start_date: null,
    permit_number: "",
    permit_start_date: null,
    permit_expiry_date: null,
    permit_status: null,
    permit_renewal_status: null,
    permit_renewal_start_date: null,
    contract_start_date: null,
    contract_expiry_date: null,
  };
  const formFields = [
    { type: "title", title: "Personal Details" },
    {
      type: "restricted",
      name: "employee_id",
      label: "Employee ID",
      regex: /[A-Za-z0-9]/i,
      required: true,
    },
    {
      type: "input",
      name: "name",
      label: "Employee Name",
      required: true,
    },
    {
      type: "reactselect",
      name: "id_type",
      label: "ID Type",
      required: true,
      proxyUrl: ID_TYPES_URL,
      paginated: true,
      getValue: getIdType ,
    },
    {
      type: "input",
      name: "id_number",
      label: "ID Number",
      required: true,
    },
    {
      type: "reactselect",
      name: "nationality",
      label: "Nationality",
      optionsDependsOn:'id_type',
      value:selectedNationalityType,
      required: true,
      proxyUrl: NATIONALITIES_LIST_URL,
      paginated: false,
      disabled:disabledNationalityType,
      groupedOptions: true,
      getValue: getNationalityType,

    },
    {
      type: "reactselect",
      name: "worker_type",
      label: "Worker Type",
      optionsDependsOn:'id_type',
      value:selectedWorkerType,
      required: true,
      proxyUrl: WORKER_TYPES_URL,
      paginated: false,
      disabled:disabledWorkerType,
      getValue: getWorkerType,

    },
    {
      type: "phone",
      name: "mobile_number",
      label: "Mobile Number",
      required: true,
    },
    {
      name: "api",
      key:"api",
      type: "switch",
      label: "API",
    //  disabled:disableswitch,
    disabled:true,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 4 },

      color: "primary",
      nolabel: "No",
      yeslabel: "Yes",
      getValue: getErmlType,




    },
    {
      type: "reactselect",
      name: "source",
      label: "Source",
      proxyUrl: SOURCE_FETCH_URL,
      required:true,
      getValue: (e) => getSourceValue(e, setDisableCompany),
      gridSize: { xs: 12, sm: 6, md: 6, lg: 6},

      paginated: true,
    },
    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      required:true,
      paginated: true,
      disabled:disableCompany,
      gridSize: { xs: 12, sm: 6, md: 6, lg: 6 },
      optionsDependsOn: "source",
      getValue: (e) => getCompanyValues(e, setDisableZone),



    },
    { type: "title", title: "Employment Details" },
    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      required:true,
      getValue: (e) => getZoneValues(e, setDisableRegion),
      paginated: true,
      disabled: disableZone,
      optionsDependsOn: "company",
    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: true,
      required:true,

      disabled:disableRegion,
      getValue: (e) => getRegionValues(e, setDisableEstate),
      optionsDependsOn: "zone",
    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL,
      required:true,

      paginated: true,
      disabled:disableEstate,
      getValue: (e) => getEstateValues(e, setDisableDivision),

      optionsDependsOn: "region",
    },
    {
      type: "reactselect",
      name: "division",
      label: "Division",
      proxyUrl: DIVISION_FETCH_URL,
      paginated: true,
      disabled:disableDivision,
      getValue: (e) => getDivisonValues(e, setDisableBlock),

      optionsDependsOn: "estate",
    },
    {
      type: "reactselect",
      name: "block",
      label: "Block",
      proxyUrl: BLOCK_FETCH_URL,
      paginated: true,
      disabled:disableBlock,

      optionsDependsOn: "division",
    },
    {
      type: "reactselect",
      name: "worker_group",
      label: "Worker Group",
      required: true,
      proxyUrl: LIST_WORKER_GROUP_URL,
      paginated: false,
      optionsDependsOn: "estate",
      filterOnType: true,
      getValue: getWorkerGroup,
    },
    {
      type: "renderonly",
      name: "supervisor",
      label: "Supervisor",
      value: supervisor?.name,
      required: false,
    },
   
  ];

  formFields.push(...documentFields);

  const formButtons = ["submit", "cancel"];

  return (
    <Form
        key={key}
      initialValues={initialValues}
      validationSchema={validationSchema}
      submitUrl={API_URL}
      listRoute={URLS.WORKER_LIST}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Worker"
    />
  );
};

export default WorkerCreateForm;
